var _defs, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3, _rect, _polygon5, _path4, _polygon6, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTataCapitalIdTufo3ITv1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 133 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #d7db29;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.73 .18 25.73 2.59 28.14 2.59 28.14 8.5 31.35 8.5 31.35 2.59 33.75 2.59 33.75 .18 25.73 .18"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "39.36 .18 42.59 8.5 39.29 8.5 37.64 3.63 36 8.5 32.68 8.5 35.93 .18 39.36 .18"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.79 .18 41.79 2.59 44.19 2.59 44.19 8.5 47.41 8.5 47.41 2.59 49.81 2.59 49.81 .18 41.79 .18"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "55.43 .18 58.66 8.5 55.35 8.5 53.7 3.63 52.05 8.5 48.75 8.5 51.99 .18 55.43 .18"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.28,8.26c-.35.18-1.15.37-2.18.37-2.66,0-4.27-1.66-4.27-4.21,0-2.75,1.92-4.42,4.48-4.42,1.01,0,1.71.21,2.02.37l-.32,1.22c-.4-.18-.96-.32-1.65-.32-1.7,0-2.93,1.07-2.93,3.07,0,1.84,1.07,2.99,2.91,2.99.61,0,1.26-.13,1.66-.3l.24,1.2.03.03Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.69.14h-1.95l-2.67,8.37h1.57l.72-2.37h2.66l.75,2.37h1.63L74.67.14h.02ZM73.66,4.98h-1.07l.66-2.07c.14-.5.27-1.09.4-1.57h.03c.13.5.26,1.07.42,1.57l.66,2.07h-1.09Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.36.77c-.46-.38-1.12-.61-2-.67h-.46c-1.01,0-1.78.06-2.34.18v8.26h1.52v-3.17c.21.05.46.06.75.06.18,0,.37,0,.54-.03.85-.08,1.58-.37,2.1-.88.46-.45.7-1.09.7-1.89s-.32-1.44-.82-1.86ZM81.36,4.16c-.16.03-.35.05-.54.05-.32,0-.54-.02-.75-.08V1.33c.16-.05.46-.08.88-.08.14,0,.29,0,.42.03.82.11,1.3.59,1.3,1.39s-.48,1.33-1.3,1.49Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.51,
    y: 0.14,
    width: 1.52,
    height: 8.37
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.39 1.42 88.01 1.42 88.01 .14 94.31 .14 94.31 1.42 91.91 1.42 91.91 8.5 90.39 8.5 90.39 1.42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.4.14h-1.95l-2.67,8.37h1.57l.72-2.37h2.66l.75,2.37h1.63L98.38.14h.02ZM97.4,4.98h-1.07l.64-2.07c.14-.5.27-1.09.4-1.57h.03v.03c.13.48.26,1.04.42,1.54l.66,2.07h-1.07Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.29 .14 103.82 .14 103.82 7.22 107.25 7.22 107.25 8.5 102.29 8.5 102.29 .14"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.73,
    y: 12.23,
    width: 81.53,
    height: 2.77
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTataCapitalIdTufo3ITv1);
export default __webpack_public_path__ + "static/media/Tata Capital_idTUFO3iTV_1.1b57c66bcff10e8c3e7d7e565fb6c321.svg";
export { ForwardRef as ReactComponent };